module.exports = "<h3 class=\"text-normal m-30\">\n    Create packages and add-on products that can be applied easily to your quotes and invoices.\n</h3>\n<hr>\n<packages-block [companyId]=\"companyId\"></packages-block>\n<product-block [companyId]=\"companyId\"></product-block>\n<discount-block [companyId]=\"companyId\"></discount-block>\n\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/packages-product/packages-product-block/product-packages-block.component.html
// module id = ./web/modern/components/packages-product/packages-product-block/product-packages-block.component.html
// module chunks = 0